// Mock data for Serenity Natural Health & Wellness

export const businessInfo = {
  name: "Serenity Natural Health & Wellness",
  tagline: "Nutritional Therapy... A Peaceful Path to Healing",
  address: "129 N Main Street, Gordon, NE 69343",
  email: "serenitywellnessne@gmail.com",
  phone: "(402) 322-1653",
  facebook: "https://www.facebook.com/profile.php?id=61556679495267",
  owner: {
    name: "Julie Hilliker",
    credentials: "BCND, LMT",
    title: "ANMA Board Certified Traditional Naturopath",
    bio: "Julie Hilliker is a dedicated Traditional Naturopath and owner of Serenity Natural Health & Wellness. With a passion for helping others achieve optimal health through natural means, Julie specializes in nutritional therapy and personalized wellness protocols. Her approach focuses on nourishing the body with abundant, high-quality nutrients to support the body's innate healing abilities."
  },
  hours: {
    monday: "9:00 AM - 5:00 PM",
    tuesday: "9:00 AM - 7:00 PM",
    wednesday: "9:00 AM - 5:00 PM",
    thursday: "9:00 AM - 5:00 PM",
    friday: "9:00 AM - 5:00 PM",
    saturday: "By Appointment",
    sunday: "Closed"
  }
};

export const orientationClass = {
  title: "Free Orientation Classes",
  description: "Join us to learn about our natural approach to health and wellness. Discover how nutritional therapy can transform your health journey.",
  schedule: "1st and 3rd Tuesday of each month",
  time: "6:30 PM",
  location: "129 N Main St., Gordon, NE",
  topics: [
    "Introduction to Traditional Naturopathy",
    "Understanding Nutritional Therapy",
    "Our 3-Step Approach to Wellness",
    "Services & Therapies Overview",
    "Q&A Session"
  ]
};

export const services = {
  coreCare: {
    title: "Core Care",
    subtitle: "Primary Focus",
    items: [
      {
        id: 1,
        name: "Nutritional Therapy Consultations",
        description: "Personalized dietary strategies and nutritional protocols designed to support your body's natural healing abilities.",
        icon: "leaf"
      },
      {
        id: 2,
        name: "Herbal Remedies & Tinctures",
        description: "Custom herbal formulations to support immune function and overall vitality.",
        icon: "flower"
      },
      {
        id: 3,
        name: "High-Quality Supplements",
        description: "Carefully selected supplements to address nutritional deficiencies and support optimal health.",
        icon: "pill"
      }
    ]
  },
  detox: {
    title: "Detox & Restoration",
    subtitle: "Comprehensive Support",
    items: [
      {
        id: 4,
        name: "Parasite Support",
        description: "Gentle protocols to support the body's natural ability to address parasitic concerns.",
        icon: "shield"
      },
      {
        id: 5,
        name: "Heavy Metal Support",
        description: "Targeted support for addressing heavy metal accumulation in the body.",
        icon: "sparkles"
      },
      {
        id: 6,
        name: "Environmental Chemical Support",
        description: "Protocols to support the body's detoxification of environmental toxins.",
        icon: "wind"
      },
      {
        id: 7,
        name: "Microbial Balance Support",
        description: "Support for addressing yeast, bacterial, and viral imbalances.",
        icon: "heart"
      }
    ]
  },
  wellness: {
    title: "Wellness Therapies",
    subtitle: "Add-On Services",
    items: [
      {
        id: 8,
        name: "Infrared Sauna",
        description: "Deep heat therapy to support detoxification and relaxation.",
        icon: "sun"
      },
      {
        id: 9,
        name: "Cryotherapy",
        description: "Cold therapy to support inflammation reduction and recovery.",
        icon: "snowflake"
      },
      {
        id: 10,
        name: "Ionic Foot Baths",
        description: "Relaxing foot baths designed to support the body's natural detox processes.",
        icon: "droplets"
      },
      {
        id: 11,
        name: "Massage Chair",
        description: "Therapeutic massage for relaxation and stress relief.",
        icon: "armchair"
      },
      {
        id: 12,
        name: "Vibration Plate Therapy",
        description: "Whole body vibration to support circulation and wellness.",
        icon: "activity"
      },
      {
        id: 13,
        name: "Ear Candling",
        description: "Traditional technique for ear wellness support.",
        icon: "flame"
      },
      {
        id: 14,
        name: "Ozone Therapy",
        description: "Oxygen-based therapy to support overall wellness.",
        icon: "cloud"
      }
    ]
  }
};

export const classes = [
  {
    id: 1,
    name: "Yoga Classes",
    description: "Gentle yoga sessions for all levels to support flexibility, relaxation, and mind-body connection.",
    schedule: "Check schedule for times",
    icon: "stretch"
  },
  {
    id: 2,
    name: "Zumba",
    description: "Fun, energetic dance fitness classes that make exercise enjoyable.",
    schedule: "Check schedule for times",
    icon: "music"
  },
  {
    id: 3,
    name: "Essential Oil Programs",
    description: "After-hours programs exploring the benefits and uses of essential oils.",
    schedule: "After hours - Check schedule",
    icon: "droplet"
  },
  {
    id: 4,
    name: "Wellness Classes",
    description: "Educational classes on various health and wellness topics.",
    schedule: "Various times",
    icon: "book"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah M.",
    location: "Gordon, NE",
    text: "Julie's nutritional therapy approach completely transformed my health. After years of struggling with chronic fatigue, I finally have my energy back. Her personalized care is unmatched.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael R.",
    location: "Rushville, NE",
    text: "The detox support program at Serenity was exactly what I needed. Julie takes the time to understand your unique situation and creates a plan that actually works.",
    rating: 5
  },
  {
    id: 3,
    name: "Linda K.",
    location: "Chadron, NE",
    text: "I attended the free orientation class and was so impressed with Julie's knowledge and caring approach. The clinic is beautiful and welcoming. Highly recommend!",
    rating: 5
  }
];

export const faqs = [
  {
    id: 1,
    question: "What is Traditional Naturopathy?",
    answer: "Traditional Naturopathy is a holistic approach to health that focuses on supporting the body's innate healing abilities through natural means. Unlike conventional medicine, we focus on identifying the root causes of health concerns and supporting the body with proper nutrition, herbs, and lifestyle changes."
  },
  {
    id: 2,
    question: "What can I expect at a Nutritional Therapy consultation?",
    answer: "During your consultation, Julie will conduct a comprehensive assessment of your health history, current concerns, and wellness goals. She'll develop a personalized nutritional protocol that may include dietary recommendations, supplements, and supportive therapies tailored to your unique needs."
  },
  {
    id: 3,
    question: "Do you accept insurance?",
    answer: "As a Traditional Naturopath, our services are typically not covered by insurance. However, we strive to make our services affordable and can discuss payment options during your consultation."
  },
  {
    id: 4,
    question: "How do I get started?",
    answer: "The best way to get started is to attend one of our free orientation classes held on the 1st and 3rd Tuesday of each month at 6:30 PM. This gives you an opportunity to learn about our approach and ask questions before scheduling a consultation."
  },
  {
    id: 5,
    question: "What should I bring to my first appointment?",
    answer: "Please bring any relevant health records, a list of current medications and supplements, and be prepared to discuss your health history and goals. Most importantly, come with an open mind and questions!"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "5 Signs Your Body May Need Nutritional Support",
    excerpt: "Learn to recognize the common signals your body sends when it's not getting the nutrients it needs for optimal function.",
    category: "Nutrition",
    date: "August 1, 2025",
    readTime: "5 min read",
    slug: "signs-body-needs-nutritional-support"
  },
  {
    id: 2,
    title: "Understanding the Importance of Detoxification",
    excerpt: "Discover why supporting your body's natural detox processes is essential for maintaining vibrant health.",
    category: "Detox",
    date: "July 25, 2025",
    readTime: "7 min read",
    slug: "understanding-detoxification"
  },
  {
    id: 3,
    title: "Herbal Remedies for Immune Support",
    excerpt: "Explore natural herbal options that can help support your immune system year-round.",
    category: "Herbal Wellness",
    date: "July 18, 2025",
    readTime: "6 min read",
    slug: "herbal-remedies-immune-support"
  }
];

export const threeSteps = [
  {
    step: 1,
    title: "Attend Orientation",
    description: "Join our free orientation class to learn about Traditional Naturopathy and our approach to wellness."
  },
  {
    step: 2,
    title: "Book Consultation",
    description: "Schedule your personalized Nutritional Therapy consultation with Julie."
  },
  {
    step: 3,
    title: "Add Wellness Services",
    description: "Enhance your healing journey with our complementary wellness therapies."
  }
];

export const images = {
  logo: "https://customer-assets.emergentagent.com/job_f023a641-4ded-490d-949c-1eed65b5f470/artifacts/h0dyav0d_IMG_6898.jpeg",
  owner1: "https://customer-assets.emergentagent.com/job_50ac767c-536b-403c-999c-426a4120ddc8/artifacts/5ahbzqqi_unnamed-2.jpg",
  owner2: "https://customer-assets.emergentagent.com/job_f023a641-4ded-490d-949c-1eed65b5f470/artifacts/1pbpo0g8_IMG_6489.jpeg",
  ownerProfessional: "https://customer-assets.emergentagent.com/job_50ac767c-536b-403c-999c-426a4120ddc8/artifacts/5ahbzqqi_unnamed-2.jpg",
  clinic: "https://customer-assets.emergentagent.com/job_f023a641-4ded-490d-949c-1eed65b5f470/artifacts/ubmvuvzb_IMG_6026.jpeg",
  flyer: "https://customer-assets.emergentagent.com/job_f023a641-4ded-490d-949c-1eed65b5f470/artifacts/en4hp7b2_IMG_6556.jpeg",
  // Pure Renewal Protocol
  pureRenewalLogo: "https://customer-assets.emergentagent.com/job_50ac767c-536b-403c-999c-426a4120ddc8/artifacts/lc4fupu2_unnamed.png",
  // Clinic images
  cryotherapy: "https://customer-assets.emergentagent.com/job_f023a641-4ded-490d-949c-1eed65b5f470/artifacts/1r0lhlvx_IMG_6015.jpeg",
  infraredSauna: "https://customer-assets.emergentagent.com/job_f023a641-4ded-490d-949c-1eed65b5f470/artifacts/9r0rbv5i_IMG_6016.jpeg",
  massageChair: "https://customer-assets.emergentagent.com/job_f023a641-4ded-490d-949c-1eed65b5f470/artifacts/wenwxh4d_IMG_6017.jpeg",
  cherryBlossom: "https://customer-assets.emergentagent.com/job_f023a641-4ded-490d-949c-1eed65b5f470/artifacts/bqippbwi_IMG_6018.jpeg",
  // New clinic images
  wellnessArea1: "https://customer-assets.emergentagent.com/job_f023a641-4ded-490d-949c-1eed65b5f470/artifacts/ze5u1x4k_IMG_6026.jpeg",
  wellnessArea2: "https://customer-assets.emergentagent.com/job_f023a641-4ded-490d-949c-1eed65b5f470/artifacts/x1lz2fyo_IMG_6027.jpeg",
  dogOnChair: "https://customer-assets.emergentagent.com/job_f023a641-4ded-490d-949c-1eed65b5f470/artifacts/kgdrwrai_IMG_6086.jpeg",
  cryotherapyRoom: "https://customer-assets.emergentagent.com/job_f023a641-4ded-490d-949c-1eed65b5f470/artifacts/5m2euezb_IMG_6098.jpeg",
  consultationArea: "https://customer-assets.emergentagent.com/job_f023a641-4ded-490d-949c-1eed65b5f470/artifacts/nwf5s9oq_IMG_6466.jpeg"
};

// Pure Renewal Protocol Data
export const pureRenewalProtocol = {
  title: "The Pure Renewal Protocol",
  tagline: "Ready to Feel Like Yourself Again?",
  description: "A powerful, all-natural detox system designed to reset your body from the inside out. Experience real energy, real clarity, and real results with our guided program available remotely.",
  benefits: [
    "Parasite Cleanse Support",
    "Heavy Metal Detoxification",
    "Environmental Chemical Cleanse",
    "Liver & Gallbladder Support",
    "Kidney & Bladder Support",
    "Colon Cleanse & Lymph Support"
  ],
  howItWorks: [
    "Inquire through our website or call us",
    "Join our private support group",
    "Receive products shipped directly to you",
    "Get guided support throughout your detox journey"
  ],
  cta: {
    phone: "(402) 322-1653",
    text: "Call or text for more information"
  }
};